import { createAction, props } from '@ngrx/store';

import * as models from '../../domain/models';

export const load = createAction('[Client.DbaList] Load');
export const loadSuccess = createAction(
  '[Client.DbaList] Load Success',
  props<{ payload: Array<models.Dba> }>()
);
